import { configureStore } from "@reduxjs/toolkit";

import ui from "./uiSlice";

/**
 * Store base. El dashboard lee datos de cohorte directamente desde los JSON
 * en /src/data (no hay capa de servicios); el store guarda estado de UI
 * transversal. Se anadiran slices segun se necesiten.
 */
export const store = configureStore({
    reducer: { ui },
});

export default store;
